import { ContextMenuOption } from '../../../models/context-menu-option';
import { EntityType } from '../../../models/enums';
import { ViewType } from '../../../models/view';
import { ObjectActionListType, ActionType, PermissionSet, Permissions } from '../../../models/permission';

enum DocumentListHeaderButtonOptionType {
    addTags = 'addTags',
    addTagsImport = 'addTagsImport',
    removeTags = 'removeTags',
    addTo = 'addTo',
    addToImport = 'addToImport',
    addToProjectData = 'addToProjectData',
    removeFrom = 'removeFrom',
    removeFromProjectData = 'removeFromProjectData',
    downloadAsPdf = 'downloadAsPdf',
    downloadNative = 'downloadNative',
    findMoreLikeThese = 'findMoreLikeThese',
    sendToDiscardPile = 'sendToDiscardPile',
    restoreFromDiscardPile = 'restoreFromDiscardPile',
    deleteFilesFromProject = 'deleteFilesFromProject',
    updateMetadata = 'updateMetadata',
    reprocess = 'reprocess',
    extractOffice365Data = 'extractOffice365Data',
    ocr = 'ocr'
}
const allDocumentListHeaderButtonOptions: ReadonlyMap<DocumentListHeaderButtonOptionType, ContextMenuOption> = new Map<DocumentListHeaderButtonOptionType, ContextMenuOption>([
    [DocumentListHeaderButtonOptionType.addTags, new ContextMenuOption({
        name: 'Add Tags ...',
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.addTagsImport, new ContextMenuOption({
        name: 'Add Tags ...',
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.removeTags, new ContextMenuOption({
        name: 'Remove Tags ...',
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.addTo, new ContextMenuOption({
        name: 'Add to ...',
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    })],
    [DocumentListHeaderButtonOptionType.addToImport, new ContextMenuOption({
        name: 'Add to ...',
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE], isMandatory: true },
        { permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    })],
    [DocumentListHeaderButtonOptionType.addToProjectData, new ContextMenuOption({
        name: 'Add to Project Data',
        iconClass: 'fa-briefcase', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        permissions: [{ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.removeFrom, new ContextMenuOption({
        name: 'Remove from ...',
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    })],
    [DocumentListHeaderButtonOptionType.removeFromProjectData, new ContextMenuOption({
        name: 'Remove from Project Data',
        iconClass: 'fa-briefcase', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        permissions: [{ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.downloadAsPdf, new ContextMenuOption({
        name: 'Download as PDF',
        iconClass: 'fa-file-pdf-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOWNLOAD_PDF })]
    })],
    [DocumentListHeaderButtonOptionType.downloadNative, new ContextMenuOption({
        name: 'Download Native',
        iconClass: 'fa-file', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOWNLOAD_NATIVES })]
    })],
    [DocumentListHeaderButtonOptionType.findMoreLikeThese, new ContextMenuOption({
        name: 'Find More Like These ...',
        iconClass: 'fa-search', iconColor: 'color-tan-07'
    })],
    [DocumentListHeaderButtonOptionType.sendToDiscardPile, new ContextMenuOption({
        name: 'Send to Discard Pile ...',
        iconClass: 'fa-recycle', iconColor: 'color-red-05',
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DISCARD_PILE, permissionActions: [ActionType.CREATE] })]
    })],
    [DocumentListHeaderButtonOptionType.restoreFromDiscardPile, new ContextMenuOption({
        name: 'Restore from Discard Pile ...',
        iconClass: 'fa-reply', iconColor: 'color-green-05',
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DISCARD_PILE, permissionActions: [ActionType.CREATE] })]
    })],
    [DocumentListHeaderButtonOptionType.deleteFilesFromProject, new ContextMenuOption({
        name: 'Delete File(s) from Project',
        permissions: [{ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.DELETE] }]
    })],
    [DocumentListHeaderButtonOptionType.updateMetadata, new ContextMenuOption({
        name: 'Update Metadata ...',
        permissions: [{ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.reprocess, new ContextMenuOption({
        name: 'Reprocess ...',
        iconClass: 'fa-retweet', iconColor: 'color-blue-01',
        permissions: [{ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.extractOffice365Data, new ContextMenuOption({
        name: 'Extract Office 365 Data ...',
        iconClass: 'fa-cloud', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-paperclip', iconSecondColor: 'color-green-04',
        tooltip: 'No available Office 365 Connectors',
        permissions: [{ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] }]
    })],
    [DocumentListHeaderButtonOptionType.ocr, new ContextMenuOption({
        name: 'OCR ...',
        permissions: [{ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] }]
    })],
]);

export const DocumentListHeaderButtonOptionsInfo: ReadonlyMap<EntityType, Array<ContextMenuOption>> = new Map<EntityType, Array<ContextMenuOption>>([
    [EntityType.import, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTagsImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToProjectData),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative)
    )],
    [EntityType.projectData, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.sendToDiscardPile)
    )],
    [EntityType.export, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
    )],
    [EntityType.exportVolume, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
    )],
    // Non Import & Data set searches
    [EntityType.searchResult, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.reprocess),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.sendToDiscardPile)
    )],
    // Import & Data set searches
    [EntityType.searchResultImport, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTagsImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToProjectData),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.updateMetadata),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.reprocess),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.extractOffice365Data),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.ocr),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.deleteFilesFromProject)
    )],
    [EntityType.comparison, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.sendToDiscardPile)
    )],
    [EntityType.clusterView, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.sendToDiscardPile)
    )],
    [EntityType.emailThread, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom)
    )],
    [EntityType.savedSearch, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTags),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTo),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.findMoreLikeThese),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
    )],
    [EntityType.exceptionView, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addTagsImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeTags),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToImport),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.addToProjectData),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFrom),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.removeFromProjectData),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative)
    )],
    [EntityType.discardPile, new Array<ContextMenuOption>(
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadAsPdf),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.downloadNative),
        new ContextMenuOption({ divider: true }),
        allDocumentListHeaderButtonOptions.get(DocumentListHeaderButtonOptionType.restoreFromDiscardPile)
    )],
]);
